import React, { useState, useEffect, useRef } from 'react'; // Importa useRef
import {
    AttachDocumentsFormItem,
    AttachDocumentsFormItemInfo,
    AttachDocumentsFormItemTitle,
    AttachDocumentsFormItemParagraph,
    AttachDocumentsLoaderContainer,
    AttachDocumentsLoader,
    AttachDocumentButton,
    AttachDocumentLabelFile
} from './styles';
import {
    UploadFileButton,
} from '../../components/Buttons/styles';
import colors from '../../assets/styles/colors';
import { FiArrowUp, FiCheck } from 'react-icons/fi';
import ModalInfo from '../../components/ModalInfo';
import { BsExclamation } from 'react-icons/bs';
import Loader from '../../components/Loader';
import eliminar from '../../assets/images/eliminarIcono.png';
import { ParagraphDelete } from './styles';

const UploadDocuments = ({ title, paragraph, inputlabel, onFileChange, fileName, onRemoveFile, isRemovable = true, isAdder = false }) => {
    const [file, setFile] = useState((fileName && !isAdder) ? { name: fileName } : null);
    const [isLoaded, setIsLoaded] = useState((fileName && !isAdder) ? true : false);
    const [error, setError] = useState('');
    const [showModalInfoError, setShowModalInfoError] = useState(false);
    const [titleErrorOnFile, setTitleErrorOnFile] = useState('');
    const [messageErrorOnFile, setMessageErrorOnFile] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const fileInputRef = useRef(null);

    useEffect(() => {
        if (!isAdder) {
            setFile(fileName ? { name: fileName } : null);
            setIsLoaded(fileName ? true : false);
        }
    }, [fileName, isAdder]);

    const handleSubmitFile = async (e) => {
        setIsLoading(true);
        const maxSize = 10 * 1024 * 1024;
        const selectedFile = e.target.files[0];
        try {
            if (!selectedFile) {
                setIsLoading(false);
                return;
            }

            if (selectedFile.size > maxSize) {
                setMessageErrorOnFile('Tamaño máximo permitido: 10MB.');
                setTitleErrorOnFile('Archivo demasiado grande');
                setShowModalInfoError(true);
            } else if (selectedFile.type !== 'application/pdf') {
                setMessageErrorOnFile('Solo se pueden cargar archivos de tipo PDF.');
                setTitleErrorOnFile('Formato de archivo inválido');
                setShowModalInfoError(true);
            } else {
                if (isAdder) {
                    onFileChange(selectedFile);
                } else {
                    setFile(selectedFile);
                    setIsLoaded(true);
                    onFileChange(selectedFile);
                }
            }
        } catch (err) {
            console.error(err);
            setFile(null);
            setError('Error al subir el archivo, reintentar');
            setMessageErrorOnFile('Ocurrió un error al cargar el archivo.');
            setTitleErrorOnFile('Error de carga');
            setShowModalInfoError(true);
        } finally {
            setIsLoading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    function modalErrorResetDefault() {
        setShowModalInfoError(false);
        setMessageErrorOnFile('');
        setTitleErrorOnFile('');
    }

    const handleDeleteFile = () => {
        if (!isAdder) {
            setFile(null);
            setIsLoaded(false);
        }
        if (onRemoveFile) {
            onRemoveFile();
        } else {
            onFileChange(null);
        }
    };

    const handleButtonClick = () => {
        if (isAdder || (!file && !fileName)) {
            fileInputRef.current?.click();
        }
    };

    return (
        <AttachDocumentsFormItem>
            <AttachDocumentsFormItemInfo>
                <AttachDocumentsFormItemTitle color={colors.textPrimary}>{title}</AttachDocumentsFormItemTitle>
                <AttachDocumentsFormItemParagraph color={colors.textPrimary}>{paragraph}</AttachDocumentsFormItemParagraph>
                <AttachDocumentsLoaderContainer>
                    <AttachDocumentsLoader percentage={(isAdder || !file) ? 0 : 100} />
                </AttachDocumentsLoaderContainer>
            </AttachDocumentsFormItemInfo>
            <AttachDocumentButton>
                <UploadFileButton uploaded={isLoaded && !isAdder} onClick={handleButtonClick} type="button" disabled={!isAdder && file}>
                    {(isAdder || !isLoaded) ? <FiArrowUp size={25} color={colors.textPrimary} /> : <FiCheck size={26} color={colors.white} />}
                </UploadFileButton>
            </AttachDocumentButton>
            <AttachDocumentLabelFile>
                {isLoaded && file && !isAdder ? (
                    <>
                        <ParagraphDelete color={colors.textPrimary} bold>
                            {file.name}
                        </ParagraphDelete>
                        {isRemovable && (
                            <img
                                height={25}
                                src={eliminar}
                                style={{ cursor: 'pointer', marginLeft: 'auto' }}
                                onClick={handleDeleteFile}
                                alt="Eliminar archivo"
                            />
                        )}
                    </>
                ) : (
                    ''
                )}
            </AttachDocumentLabelFile>
            {(isAdder || !fileName) && (
                <input
                    type="file"
                    accept="application/pdf"
                    id={inputlabel}
                    name={inputlabel}
                    style={{ display: 'none' }}
                    onChange={handleSubmitFile}
                    ref={fileInputRef}
                />
            )}
            {isLoading && <Loader />}
            <ModalInfo
                open={showModalInfoError}
                setShowModal={modalErrorResetDefault}
                title={titleErrorOnFile}
                description={messageErrorOnFile}
                backgroundIcon={colors.bgDanger}
                bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
            />
        </AttachDocumentsFormItem>
    );
};

export default UploadDocuments;